<script setup>
import { computed } from 'vue';

import WootLabel from 'dashboard/components-next/label/Label.vue';
import {
  BaseTable,
  BaseTableRow,
  BaseTableCell,
} from 'dashboard/components-next/table';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

defineProps({
  actions: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
});

const { t, formatStatus, labelColor } = useAutomationOperationsFormatters();

const replayHeaders = computed(() => [
  t('AUTOMATION.OPERATIONS.REPLAY.TABLE_HEADER.ACTION'),
  t('AUTOMATION.OPERATIONS.REPLAY.TABLE_HEADER.DECISION'),
  t('AUTOMATION.OPERATIONS.REPLAY.TABLE_HEADER.RESULT'),
  t('AUTOMATION.OPERATIONS.REPLAY.TABLE_HEADER.IDEMPOTENCY'),
]);
</script>

<template>
  <BaseTable
    class="mt-4"
    :headers="replayHeaders"
    :items="actions"
    :loading="isLoading"
    :loading-message="$t('AUTOMATION.OPERATIONS.REPLAY.LOADING')"
    :no-data-message="$t('AUTOMATION.OPERATIONS.REPLAY.EMPTY_PLAN')"
  >
    <template #row="{ items }">
      <BaseTableRow
        v-for="action in items"
        :key="action.action_ref"
        :item="action"
        :state="action.decision?.status === 'blocked' ? 'error' : 'default'"
      >
        <template #default>
          <BaseTableCell>
            <div class="flex min-w-0 flex-col gap-1">
              <span class="truncate text-body-main text-n-slate-12">
                {{ action.action_ref }}
              </span>
              <span class="truncate text-body-main text-n-slate-11">
                {{ action.action_name }}
              </span>
            </div>
          </BaseTableCell>
          <BaseTableCell>
            <div class="grid gap-1">
              <WootLabel
                :label="formatStatus(action.decision?.status)"
                :color="labelColor(action.decision?.status)"
                compact
              />
              <span
                v-if="action.decision?.reason"
                class="text-body-main text-n-slate-11"
              >
                {{ formatStatus(action.decision.reason) }}
              </span>
              <span
                v-if="action.decision?.requires_force"
                class="text-body-main text-n-ruby-11"
              >
                {{ formatStatus('requires_force') }}
              </span>
              <span
                v-if="action.decision?.requires_new_idempotency_key"
                class="text-body-main text-n-amber-11"
              >
                {{ formatStatus('requires_new_idempotency_key') }}
              </span>
            </div>
          </BaseTableCell>
          <BaseTableCell>
            <span class="text-body-main text-n-slate-11">
              {{ formatStatus(action.latest_attempt?.result) }}
            </span>
          </BaseTableCell>
          <BaseTableCell>
            <span class="break-all text-body-main text-n-slate-11">
              {{
                action.diff?.idempotency_change ||
                action.plan?.idempotency_key_digest ||
                '-'
              }}
            </span>
          </BaseTableCell>
        </template>
      </BaseTableRow>
    </template>
  </BaseTable>
</template>
